import React, {useContext} from "react";
import "react-multiple-select-dropdown-lite/dist/index.css";
import "../css/custom-dropdown.scss";
import {DropdownButton, Dropdown} from "react-bootstrap";

import {AppContext} from "../App";

import Headline from "./common/headline";

export default function Steps() {
    const { data, setData } = useContext(AppContext);
    let { steps, products, challenges, stepsTitle } = data;

    const challengesSelected = challenges
        .filter(challenge => challenge.selected)
        .map(challenge => challenge.id);

    const toggleSteps = (step) => {
        let newSteps = steps.map(step => {
          step.selected = false;

          return step;
        });

        products.map(product => {
          product.selected = true;
          product.disabled = false;

          return product;
        });

        step.selected = !step.selected;

        setData({
            steps: newSteps,
            ...data
        })
    }

    const clearSteps = () => {
        let clearedSteps = steps.map(step => step.selected = false);

        let clearedProducts = products
            .filter(product => {
                const {challengesIDs} = product;

                product.selected = true;
                product.disabled = false;

                if (product.selected) {
                    return challengesIDs.some(challengeIndex => challengesSelected.includes(challengeIndex));
                } else {
                    return false;
                }
            });

        let initialTitle = 'Select mAb Workflow step';

        setData({
            steps: clearedSteps,
            products: clearedProducts,
            ...data,
            stepsTitle: initialTitle,
        })
    }

    const setTitle = (title) =>{
        setData({
            ...data,
            stepsTitle: title
        })
    }

    const renderItems = steps.map((step) => {
        return <Dropdown.Item eventKey={step.name} key={step.id} onClick={() => toggleSteps(step)}>{step.name}</Dropdown.Item>
    })

    return (
        <div className="workflow-configurator">
            <Headline counter={2} title={'Select Workflow Step'} filters={true} clearSteps={clearSteps} />
            <DropdownButton title={`${stepsTitle}`} onSelect={setTitle} id="dropdown-menu-align-right">
                { renderItems }
            </DropdownButton>
        </div>
    );
}